import script from "./Karies.vue?vue&type=script&setup=true&lang=ts"
export * from "./Karies.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__